// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Rgt6","empty":"ModalGraph_empty__26anv"};